import React from 'react';
import { SimpleBlock, TextLink } from 'ui-builder';
import { useMarketRequestsService } from 'nekst-api';
import { useDataLoaderNew } from 'data-loader';

import styles from './MarketRequestsLinkWidget.module.scss';
import useSettingsNavigator from '../../settingsNavigator';

export default function MarketRequestsLinkWidget() {
  const marketRequestsService = useMarketRequestsService();
  const settingsNavigator = useSettingsNavigator();

  const { data: requests } = useDataLoaderNew(
    marketRequestsService.getMarketRequests
  );

  if (requests && requests.length > 0) {
    return (
      <SimpleBlock className={styles.link}>
        <TextLink
          onClick={async () => {
            settingsNavigator.openMarketRequestsPage(false);
          }}
        >
          View Your Market Requests ({requests.length.toString(10)})
        </TextLink>
      </SimpleBlock>
    );
  } else {
    return null;
  }


}
